import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';

export const AdfEmoji = React.memo(({ node }: AdfNodeProps) => {
    const { shortName, text, id } = node.attrs || {};

    if (text) {
        return <span className="emoji" title={shortName}>{text}</span>;
    }

    return <span className="emoji" title={shortName}>{shortName}</span>;
});
